<template>
    <div class="form-group">
        <label :for="id.ID()" :class="{'sr-only': srOnly}">
            <slot name="label">{{ label }}</slot>
        </label>
		<input
            :id="id.ID()"
			:aria-label="label"
			type="text"
			v-model="getCurrentSelection"
			class="form-control"
			@click="selectSearch"
			@keyup.enter="selectSearch"
			ref="student"
		/>
    </div>
</template>

<script>
import id from 'src/modules/uuid.js'

export default {
    props: {
        label: {
            type: String,
            required: true,
        },
        srOnly: { // If true, hides label except as an aria-label for screen-readers.
            type: Boolean,
            default: false,
        },
        value: undefined,
        options: [Array, Object],
        optionLabel: String,    // Use with objects to specify the label field
        optionValue: String,    // Use with objects to specify the value field
        indexIsValue: {   // Set this to true if you wish to use the v-for index as the value.
            type: Boolean,
            default: false,
        },
        labelCb: Function,  // Called on the options to set their label // NOT IMPLEMENTED
        valueCb: Function,  // Called on the options to set their value // NOT IMPLEMENTED
        nullable: {
            type: Boolean,
            default: true,
        },
        nullLabel: {
            type: String,
            default: '',
        },
        error: Boolean,
    },
    data() {
        return {
            id: new id(),
            innerValue: this.value,
        }
    },
    watch: {
    	value: function() {
    		this.innerValue = this.value;
    	},
    },
    methods: {
        selectSearch() {
			const self = this;
			var options = JSON.parse(JSON.stringify(this.options));
			if(this.nullable){
				var nullval = {};
				nullval[self.optionValue] = 0;
				nullval[self.optionLabel] = this.$t('all');
				options.unshift(nullval);
			}
			this.$store.commit("openModal", {
				type: "selector",
				title: this.label,
				selectCallback: function(selection) {
					self.innerValue = selection[self.optionValue];
           			self.$emit('input', self.innerValue)
					self.$store.commit("closeModal");
				},
				selected: [{
					id: this.innerValue
				}],
				data: options,
				captionKey: this.optionLabel
			});
        }
    },
    computed: {
    	getCurrentSelection(){
    		var selection = this.options.find(item => {
				return item[this.optionValue] == this.innerValue
			});
			if(selection){
				return selection[this.optionLabel];
			}
			return '';
    	}
    }
}
</script>
